import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'chip-list-section',
  styleUrl: 'chip-list-section.css',
})
export class ChipListSection {
  @Prop() sectionTitle: string;
  @Prop() addClick: () => void;
  @Prop() addButtonText?: string = 'Add';
  @Prop() size?: string = '12';

  render() {
    return (
      <ion-row>
        <ion-col size={this.size}>
          <ion-label class="typography-body2-400" style={{ marginBottom: '6px', color: 'var(--background-color-step-950)' }}>
            {this.sectionTitle}
          </ion-label>
        </ion-col>
        <ion-col size={this.size} class="ion-display-flex ion-flex-wrap ion-align-items-center">
          <slot />
          <ion-button fill="clear" shape="round" size="small" onClick={() => this.addClick()}>
            <ion-icon slot="start" name="add-outline" color="primary"></ion-icon>
            {this.addButtonText}
          </ion-button>
        </ion-col>
      </ion-row>
    );
  }
}
